
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#E5E5E5"}}),_c('path',{attrs:{"d":"M4.996 11.832a.37.37 0 01-.523-.003.365.365 0 010-.52l3.153-3.153-3.151-3.152a.37.37 0 11.524-.524L8.15 7.632l3.153-3.153a.37.37 0 11.524.523L8.674 8.155l3.151 3.152a.37.37 0 11-.523.524L8.15 8.678l-3.154 3.153z","fill":"#707070"}})])
          )
        }
      }
    